import { render, staticRenderFns } from "./addReportCustomGroup.vue?vue&type=template&id=3367f7d8"
import script from "./addReportCustomGroup.vue?vue&type=script&lang=js"
export * from "./addReportCustomGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports